import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/SpireConnect.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SpireConnectPopup = (props) => {
  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
  }, []);

  console.log("asc56 props", props);

  return (
    <>
      <Modal
        id="asc"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="text-center">
          <div>
            <p className="spireTextPopup pt- m-0 d-none">
              {t("This data will be removed from the system")}
            </p>
            <p className="spireTextPopup m-0 px-5">
              {props.DynamicContent && props.DynamicContent}
            </p>
          </div>

          <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
            <div className="btnNoDiv d-none">
              <button className="btnNo p-2" onClick={props.onHide}>
                {t("No")}
              </button>
            </div>

            <div
              className="btnYesDiv ascButton"
              style={{ background: "#00246A", border: "1px solid #00246A" }}
            >
              {/* <button onClick={props.handleDelete}>yes</button> */}

              <button className="btnYes p-2" onClick={props.handleDelete}>
                {/* {fetchTransPlanBoadList[22]?.translation} */}
                {props.DynamicButtonText && props.DynamicButtonText}
                {props.loading === true && (
                  <div
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                  ></div>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* <Button variant="primary" onClick={handleShow}>
                Launch demo modal
            </Button>

            <Modal show={show} onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal> */}
    </>
  );
};

export default SpireConnectPopup;
